import { Record, RecordOf } from 'immutable';



export type SignInRequest = RecordOf<SignInRequestProperties>;
//const url = window['__CPC__']()['urls'];

export interface SignInRequestProperties {
  username: string;
  password: string;
  rememberUsername: boolean;
  captchaToken: string;
  skip2fvSetUp: boolean;
  contextRequest : {
    businessUrl: string;
    personalUrl: string;
    sourceUrl: string;
    authLevel: string;
    ipAddress: string;
    targetUrl: string;
    language: string;
  }
}


export class SignInRequestFactory {
  //url = window['__CPC__']()['urls'];
  static readonly create = Record<SignInRequestProperties>({
    username: null,
    password: null,
    rememberUsername: false,
    captchaToken: "",
    skip2fvSetUp: false,
    contextRequest :{
    businessUrl: "",
    personalUrl: "",
    sourceUrl: "",
    authLevel: "",
    ipAddress: "",
    targetUrl: "",
    language: localStorage.getItem('locale')

    }
  });
}
